export default "__VITE_ASSET__iK5yxb67__"